import styled, { CSSObject } from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export type HeadingLevels = 1 | 2 | 3 | 4 | 5 | 6

export const HeadingStyled = (level: HeadingLevels) => {
  let styles: CSSObject

  switch (level) {
    default:
    case 1:
      styles = {}
      break
    case 2:
      styles = {}
      break
    case 3:
      styles = {
        backgroundColor: hexColors.gainsboro,
        color: hexColors.nightRider,
        fontSize: '1.2rem',
        fontWeight: 'bold',
        textTransform: 'none',
      }
      break
    case 4:
      styles = {}
      break
    case 5:
      styles = {}
      break
    case 6:
      styles = {}
      break
  }

  return styled(`h${level}` as `h${HeadingLevels}`)({ ...styles })
}

// Minor Third Scale - 1.200
const HeadingBase = styled.div({
  margin: '3rem 0 1.38rem',
  fontWeight: 400,
  lineHeight: 1.3,
  textAlign: 'left',
  textTransform: 'unset',
  color: hexColors.nero,
  background: 'none',
  padding: 0,
})

export const H3 = styled(HeadingBase)({
  fontSize: '1.728rem',
}).withComponent('h3')
